<template>
  <div id="app">
    <!-- <keep-alive>
    <router-view  ref="child"></router-view>
     </keep-alive> -->
    <keep-alive>
      <router-view ref="child" v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view ref="child" v-if="!$route.meta.keepAlive"></router-view>

    <div class="learnOver" v-if="showModal">
      <div class="cardModal">
        <img src="./assets/images/tips.png" alt="" />

        <div class="tipsword">今天的学习时间已经用完啦!</div>
        <div class="tipsword">请明天再来学习吧~</div>
        <div class="know" @click="toknow">我知道了</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showTabbar: false,
      showTipsModal: false,
      surplusTime: "2021-1-10 16:09:00",
      seconds: "",
    };
  },

  created() {
    window.PushToken = (token) => {
      if (token) {
        this.$store.commit("SET_TOKEN", token);
      } else {
        this.$store.commit("REMOVE_TOKEN", true);
      }

      this.$refs.child.initPage && this.$refs.child.initPage();

      //     http.getUserSelfStudyTime().then(res=>{

      //     localStorage.setItem('userInfo',JSON.stringify(res))
      // })
    };
    

    window.getStatusbarHeight = (height) => {
      this.$store.commit("SET_Height", parseInt(height));
    };
  },
  computed: {
    showModal() {
      return this.$store.state.showTipsModal;
    },
  },
  mounted() {
    console.log(this.$route.meta.keepAlive);
  },
  methods: {
    countDownSelf() {
      //自学倒计时
      if (this.modalTimer) {
        clearInterval(this.modalTimer);
      }

      let now = new Date().getTime() / 1000;
      let overTime = new Date(this.surplusTime).getTime() / 1000;
      this.seconds = overTime - now;
      if (this.seconds > 0) {
        this.modalTimer = setInterval(() => {
          this.seconds--;
          console.log(this.seconds);
          if (this.seconds <= 0) {
            clearInterval(this.modalTimer);
            let value = this.$route.path;
            if (value == "SelfStudyList" || value == "SelfStudyIntro") {
              this.$store.commit("Set_ModalVisible", true);
            }
          }
        }, 1000);
      } else {
        this.$store.commit("Set_CanLearn", {});
      }
    },
    toknow() {
      this.$store.commit("Set_ModalVisible", false);
    },
  },
  watch: {},
};
</script>

<style lang="less">
::-webkit-scrollbar {
  width: 0px;
}
#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
  // color: #333333;
  // font-size: 14px;
}
.learnOver {
  position: fixed;
  top: 0;
  z-index: 9999;
  width: 100%;
  height: 100vh;
  background: rgba(20, 19, 26, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .cardModal {
    width: 327px;
    height: 203px;
    background: #ffffff;
    border-radius: 6px;
    display: flex;
    align-items: center;
    flex-direction: column;
    img {
      width: 40px;
      height: 40px;
      margin-top: 32px;
      margin-bottom: 24px;
    }
    .tipsword {
      font-size: 15px;
      color: rgba(34, 32, 48, 0.65);
    }
    .know {
      font-size: 16px;
      color: #fc541e;
      margin-top: 29px;
    }
  }
}
</style>
